import { type AiAgentId } from '@fruitful/llm-service-shared';
import { BodySmallRegular, Spinner, YStack } from 'smoothie';

import { useListMastraThreads } from '../hooks/useListMastraThreads';
import { AiDashboardThreadsTable } from './AiDashboardThreadsTable';

export const AiDashboardAgentPanel = ({
    agentId,
    resourceId,
}: {
    agentId: AiAgentId;
    resourceId: string | null;
}) => {
    const {
        data: threads = [],
        isLoading,
        isRefetching,
        error,
        refetch,
    } = useListMastraThreads({
        agentId,
    });

    if (isLoading) {
        return <Spinner />;
    }

    if (error != null) {
        return (
            <BodySmallRegular color="$red1100">
                Unable to load AI conversations.
            </BodySmallRegular>
        );
    }

    return (
        <YStack
            flex={1}
            minHeight={0}
            height="100%"
            width="100%"
            gap={16}
            padding={8}
            overflow="hidden"
        >
            <AiDashboardThreadsTable
                threads={threads}
                agentId={agentId}
                resourceId={resourceId}
                isRefreshing={isRefetching}
                onRefresh={() => {
                    void refetch();
                }}
            />
        </YStack>
    );
};
